/* eslint-disable @nx/enforce-module-boundaries */
import {
  AfterViewInit,
  Component,
  DestroyRef,
  Input,
  OnDestroy,
  ViewChild,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  BaseListItems,
  CardTableComponent,
  ConfirmDialogService,
  CustomPaginator,
  FilterParams,
  LoaderIndicatorDirective,
  SearchComponent,
} from '@t-llevo/common-ui';
import { MatSort, MatSortModule } from '@angular/material/sort';
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
} from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { apiUserRoutes as apiRoutes } from '../../../api/routes/api-user-routes';
import { Driver } from 'admin-drivers/src/app/common/models/Driver';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { UserService } from '../../../api/services/user.service';
import { User } from 'admin-drivers/src/app/common/models/User';
import { UserResponse } from 'admin-drivers/src/app/api/models/responses/UserResponse';
import { ResponseData } from '@t-llevo/util';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { last, merge, tap } from 'rxjs';
import { ClientChangePasswordComponent } from '../client-change-password/client-change-password.component';

@Component({
  selector: 't-llevo-client-list',
  standalone: true,
  imports: [
    CommonModule,
    CardTableComponent,
    SearchComponent,
    MatIconModule,
    LoaderIndicatorDirective,
    MatTableModule,
    MatMenuModule,
    MatPaginatorModule,
    MatButtonModule,
    MatSortModule,
  ],
  templateUrl: './client-list.component.html',
  providers: [
    ConfirmDialogService,
    { provide: MatPaginatorIntl, useValue: CustomPaginator() },
  ],
  styles: `
    .mat-column-actions {
      display: flex;
      justify-content: center;
    }
  `,
})
export class ClientListComponent
  extends BaseListItems<User, ResponseData<UserResponse>>
  implements OnDestroy, AfterViewInit
{
  @Input() searchTerm = '';
  displayedColumns: string[] = ['email', 'name', 'lastname', 'actions'];
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  showDrawer = false;
  destroyRef = inject(DestroyRef);

  constructor(
    public dialog: MatDialog,
    private userService: UserService,
  ) {
    super(userService, apiRoutes.routeGetClientList);
  }

  ngOnDestroy(): void {
    this.stop$.next(true);
    this.stop$.complete();
  }
  ngAfterViewInit(): void {
    this.sort.sortChange
      .pipe(takeUntilDestroyed(this.destroyRef), last())
      .subscribe(() => (this.paginator.pageIndex = 0));
    merge(this.paginator.page, this.sort.sortChange)
      .pipe(tap(() => this.loadItems(this._getFiltersParams())))
      .subscribe();
    this.loadItems(this._getFiltersParams());
  }

  openDeleteDialog(user: User) {
    const config = {
      title: `¿Desea eliminar el elemento?`,
      message: 'El elemento se eliminará de forma permanente',
      cancelText: 'CANCELAR',
      confirmText: 'SI, DESEO ELIMINAR',
    };
    this.confirmDialogSrv.open(config).subscribe((dataDialog) => {
      if (dataDialog) {
        this.userService.deleteUserById(user.id).subscribe({
          next: () => {
            this.notifySrv.dispatch('Usuario eliminado', 'success');
            this.loadItems();
          },
        });
      }
    });
  }

  _getFiltersParams(defaultField = 'name'): FilterParams {
    const activeField =
      this.sort && this.sort.active ? this.sort.active : defaultField;
    const params: FilterParams = {
      page: this.paginator ? this.paginator.pageIndex + 1 : 1,
      limit: this.paginator ? this.paginator.pageSize : 10,
      roles: 'client',
  
    };
    if (this.searchParam) {
      params['search'] = this.searchParam;
    }

    return params;
  }

  override onSearch(ev: string): void {
    if (this.searchParam !== ev || this.searchParam === '') {
      this.searchParam = ev;

      this.loadItems(this._getFiltersParams())
    }
  }

  detail(item: Driver): void {
    this.showDrawer = !this.showDrawer;
    this.selectItem(item.id);
  }

  openedDrawerChange(open: boolean) {
    this.showDrawer = open;
  }

  openChangePasswordDialog(user: User) {
    this.dialog.open(ClientChangePasswordComponent, {
      data: user,
      width: '50%',
      maxHeight: '70%',
      disableClose: true,
    });
  }

  private selectItem(id: string) {
    this.userService.getItem('', id, false);
  }
}
